// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_A9EDc clearfix","box_r":"index_box_r_WndrZ","d_box":"index_d_box_RwrW9"};